<template>
  <div>
    <custom-callout
      ref="detail-ref"
      :border-color-hex="statusSetColor"
      class-main="mt-3 rounded"
      :has-toggle="true"
      :controlled="true"
      :opened="data.isOpen"
      @click:open="toggleCallout(enums.TAB_ITEMS.First)"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-12 col-md-2" :class="!isMobile ? 'text-center' : ''">
          <div class="d-flex flex-column color-black mb-3">
            <div
              :class="
                `mb-1 font-light badge badge-pill font-16 py-2 mt-2 w-90 mx-auto badge-${statusColorClass}`
              "
            >
              {{ data.referralStatus | empty }}
            </div>
            <span class="font-16 font-weight-bold">
              {{ data.caseNumber | empty }}
            </span>
          </div>
        </div>
        <div class="col-md-8 border-left">
          <div class="row mb-3">
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block border-mobile"
                >Nombre del Estudiante:</span
              >
              <span class="font-16 color-black">
                {{ data.fullName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block border-mobile"
                >Mes de Solicitud:</span
              >
              <span class="font-16 color-black">
                {{ data.month | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Tipo de Solicitud:</span>
              <span class="font-16 color-black">
                {{ getRequestTypeDescription | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 my-2">
              <span class="data-title d-block">Estatus del Estudiante EE:</span>
              <span class="font-16 color-black">
                {{ data.studentRegStatus | empty }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-2 col-lg-2 mt-2 mt-lg-0">
          <div class="text-right">
            <div class="dropdown">
              <action-button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="onActionsButtonClick"
              >
                Acciones
              </action-button>
              <div class="dropdown-menu dropdown-menu-right">
                <action-button
                  type="button"
                  class="dropdown-item cursor-pointer text-left border-bottom"
                  i="fas fa-file-import fa-fw text-green mr-2"
                  id="referralPartCToPartBEnterDetailBtn"
                  @click="goToDetail(data)"
                  text="Entrar"
                />
                <action-button
                  v-if="isCompleted"
                  type="button"
                  class="dropdown-item cursor-pointer text-left border-bottom"
                  i="fas fa-file-alt text-green mr-2"
                  id="referralPartCToPartBRedirectToCommentBtn"
                  @click="() => onCommentRedirect()"
                  text="Comentario"
                />
                <action-button
                  v-if="isCompleted"
                  type="button"
                  class="dropdown-item cursor-pointer text-left border-bottom"
                  i="fas fa-comment fa-fw text-green mr-2"
                  id="referralPartCToPartBAddCommentBtn"
                  @click="() => onShowAddCommentPanel()"
                  text="Añadir Comentario"
                />
                <action-button
                  v-if="!isHealthReferral"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  i="fas fa-file-search fa-fw text-green mr-2 ml-1"
                  id="referralPartCToPartBAddProcedureBtn"
                  @click="onAddProcedureHandler"
                  text="Gestionar"
                />
                <action-button
                  v-if="data.hasProcedureLog"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  i="fas fa-file-search fa-fw text-green mr-2 ml-1"
                  id="referralPartCToPartBProcedureHistoryBtn"
                  @click="onShowProcedureHistoryHandler"
                  text="Historial de Gestiones"
                />
                <action-button
                  v-if="showInactivateReferral"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  i="fas fa-empty-set fa-fw text-red mr-2 ml-1"
                  id="referralPartCToPartBInactivateBtn"
                  @click="onInactivateReferralHandler"
                  text="Inactivar"
                />
                <action-button
                  v-if="showCreatePreRegister"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  @click="() => $emit('on-create-pre-register', data)"
                  id="referralPartCToPartBCreatePreRegisterBtn"
                  i="fas fa-user-friends fa-fw text-green mr-2 ml-1"
                  text="Crear Pre-Registro"
                />
                <action-button
                  v-if="showDeleteSIE"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  @click="() => $emit('on-delete-sie', data)"
                  id="referralPartCToPartBDeleteSIE"
                  i="fas fa-times-circle fa-fw text-red mr-2 ml-1"
                  text="Eliminar Relación"
                />
                <action-button
                  v-if="canDeleteReferral"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  @click="() => $emit('on-delete-referral', data)"
                  id="deleteRow"
                  i="fas fa-times-circle fa-fw text-red mr-2 ml-1"
                  text="Eliminar"
                />
                <action-button
                  v-if="showChangeStatus"
                  type="button"
                  class="dropdown-item cursor-pointer text-left"
                  @click="() => onShowChangeStatusPanel()"
                  id="changeStatus"
                  i="fas fa-exchange-alt fa-fw text-green mr-2 ml-1"
                  text="Cambiar Estatus"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <add-comment-form
          v-if="showAddCommentPanel"
          @cancel="onCancelAddCommentHandler"
          @submit="onSaveAddCommentHandler"
        />
        <div v-else class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <div v-if="data.showRequestProcedureAdd">
                  <request-procedure-add
                    :id="data.pcStudentId"
                    :request-type-id="data.requestTypeId"
                    @cancel="onCancelProcedureHandler"
                    @saved="onSavedProcedureHandler"
                  />
                </div>
                <custom-tab
                  v-if="
                    !data.showRequestProcedureAdd &&
                      !showChangeStatusPanel &&
                      !showAddCommentPanel
                  "
                  content-class="mt-3"
                  :default-active-tab="activeTab"
                  :no-nav-style="true"
                  nav-class="nav-vue-underline"
                >
                  <custom-tab-item class="mt-2" title="Información Adicional">
                    <additional-information :existing-data="data" />
                  </custom-tab-item>
                  <custom-tab-item
                    v-if="data.hasProcedureLog"
                    class="mt-2"
                    title="Historial"
                  >
                    <request-procedure-history :items="referralProcedureLogs" />
                  </custom-tab-item>
                </custom-tab>
                <div v-if="showChangeStatusPanel">
                  <request-procedure-change-status
                    :id="data.pcStudentId"
                    :status-id="data.statusId"
                    :request-type-id="data.requestTypeId"
                    :student-sie-id="data.studentSieId"
                    @cancel="onCancelChangeStatusHandler"
                    @saved="onSavedChangeStatusHandler"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
    <div v-if="isAgeOutsideTerm" class="d-flex">
      <custom-error
        class="col-12 m-0 border-top-0"
        :is-alert-mode="true"
        :message="
          `La edad ${studentAge} de la solicitud del referido se encuentra fuera de término.`
        "
      />
    </div>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import CustomError from "custom-error";
import store, { modulesName } from "@/store/index";
import referralStatus from "@/utils/constants/student/referralStatus";
import { CustomTab, CustomTabItem } from "custom-tabs";
import AdditionalInformation from "./AdditionalInformation";
import RequestProcedureAdd from "./RequestProcedureAdd";
import RequestProcedureChangeStatus from "./RequestProcedureChangeStatus";
import RequestProcedureHistory from "./RequestProcedureHistory";
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";
import Ages from "@/utils/constants/student/partCpartBAges";
import alert from "@/mixin/alert.mixin";
import referralStudentService from "@/services/pc/referral-student";
import { AddCommentForm } from "@quisit/comments";
import studentService from "@/services/student.js";
import objectToFormData from "object-to-formdata";
import commentTypes from "@/utils/constants/comment/commentTypes";
import commentCategories from "@/utils/constants/comment/commentTypes";
import viewTypes from "@/utils/constants/comment/CodeViewTypes.js";

const TAB_ITEMS = {
  First: 0,
  ProcedureHistory: 1
};

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    ActionButton,
    CustomError,
    CustomTab,
    CustomTabItem,
    AdditionalInformation,
    RequestProcedureAdd,
    RequestProcedureHistory,
    RequestProcedureChangeStatus,
    AddCommentForm
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    enums: { TAB_ITEMS },
    activeTab: TAB_ITEMS.First,
    showChangeStatusPanel: false,
    showAddCommentPanel: false,
    referralProcedureLogs: []
  }),
  computed: {
    getRequestTypeDescription() {
      let description = "-";
      if (this.data.requestTypeId)
        description =
          this.data.requestTypeId == publicPortalRequestTypes.HealthReferral
            ? "Referido de Salud"
            : "Preregistro en Línea";
      return description;
    },
    statusSetColor() {
      switch (this.data.referralStatusId) {
        case referralStatus.New:
          return "#B5C3BC";
        case referralStatus.Submitted:
          return "#F8EA80";
        case referralStatus.Completed:
          return "#A3E5B3";
        case referralStatus.Related:
          return "#ddb3d7";
        default:
          return null;
      }
    },
    isCompleted() {
      return this.data.referralStatusId == referralStatus.Completed;
    },
    statusColorClass() {
      switch (this.data.referralStatusId) {
        case referralStatus.New:
        case referralStatus.Inactive:
          return "gray";
        case referralStatus.Submitted:
          return "yellow";
        case referralStatus.Completed:
          return "green-light";
        case referralStatus.Related:
          return "violet";
        default:
          return null;
      }
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    showCreatePreRegister() {
      if (this.data.requestTypeId == publicPortalRequestTypes.HealthReferral) {
        return (
          this.data.referralStatusId == referralStatus.Related &&
          this.$store.getters.HasPermission(
            "student.referralcparttobpart.createpreregister"
          )
        );
      } else {
        return (
          this.data.referralStatusId == referralStatus.Related &&
          this.$store.getters.HasPermission(
            "student.referralregonline.createpreregister"
          )
        );
      }
    },
    showDeleteSIE() {
      return this.data.referralStatusId == referralStatus.Related;
    },
    canDeleteReferral() {
      const canDeleteHealthReferral =
        this.isHealthReferral &&
        this.$store.getters.HasPermission(
          "student.referralpartcpartb.view.deletehealthreferral"
        );
      const canDeleteOnlineRegistryReferral =
        this.isOnlineRegistration &&
        this.$store.getters.HasPermission(
          "student.referralpartcpartb.view.deleteonlineregistryreferral"
        );

      return (
        this.data.referralStatusId === referralStatus.New &&
        (canDeleteHealthReferral || canDeleteOnlineRegistryReferral)
      );
    },
    showChangeStatus() {
      return (
        this.data.referralStatusId != referralStatus.New &&
        this.$store.getters.HasPermission("student.partcpartb.changestatus")
      );
    },
    isHealthReferral() {
      return (
        this.data.requestTypeId === publicPortalRequestTypes.HealthReferral
      );
    },
    isOnlineRegistration() {
      return (
        this.data.requestTypeId === publicPortalRequestTypes.OnlineRegistration
      );
    },
    studentAge() {
      return this.data?.age ?? "-";
    },
    isAgeOutsideTerm() {
      return (
        this.data?.age &&
        this.data.age >= Ages.VALIDATION_AGE &&
        this.data.age <= Ages.MAXIMUM_AGE
      );
    },
    showInactivateReferral() {
      return (
        (this.data.referralStatusId == referralStatus.New ||
          this.data.referralStatusId == referralStatus.Submitted) &&
        this.isOnlineRegistration &&
        this.referralIsValidToInactivate
      );
    },
    referralIsValidToInactivate() {
      return this.referralProcedureLogs.length >= 3;
    }
  },
  methods: {
    toggleCallout(activeTabIdx = null) {
      this.data.isOpen = !this.data.isOpen;
      this.data.showRequestProcedureAdd = false;
      this.activeTab = activeTabIdx ?? TAB_ITEMS.First;
    },
    onShowChangeStatusPanel() {
      this.showChangeStatusPanel = true;
      this.showAddCommentPanel = false;
      this.data.isOpen = true;
    },
    async onCommentRedirect() {
      const hasDifferentStudentSelected = store.state.$_student.selectedStudent
        ? true &&
          store.state.$_student.selectedStudent.studentId.toString() !==
            this.data.studentSieId.toString()
        : false;
      let response;
      if (hasDifferentStudentSelected) {
        response = await this.ShowCancelModal(
          "Atención",
          "El sistema detectó que se cambió el estudiante, usted será redireccionado al menú principal. ¿Está seguro que desea continuar?",
          "Sí",
          "No"
        );
      }
      if (response || !hasDifferentStudentSelected) {
        this.$router.push({
          name: "studentAddComment",
          params: {
            commentDate: new Date(),
            studentSieId: this.data.studentSieId,
            categoryId: commentCategories.ReferidosParteCAParteB,
            codeViewTypeId: viewTypes.AnadirComentario
          }
        });
      } else {
        return false;
      }
    },
    onShowAddCommentPanel() {
      this.showAddCommentPanel = true;
      this.showChangeStatusPanel = false;
      this.data.isOpen = true;
    },
    goToDetail(item) {
      if (this.data.requestTypeId === publicPortalRequestTypes.HealthReferral) {
        this.$router.push({
          name: "detailReferral",
          params: {
            pcStudentId: item.pcStudentId,
            status: item.referralStatus
          }
        });
        return;
      }
      this.$router.push({
        name: "registrationDetail",
        params: { registrationId: item.pcStudentId }
      });
    },
    async onAddProcedureHandler() {
      this.data.isOpen = true;
      this.data.showRequestProcedureAdd = true;
      await this.$forceUpdate();
    },
    async onCancelProcedureHandler() {
      this.data.isOpen = false;
      this.data.showRequestProcedureAdd = false;
      await this.$forceUpdate();
    },
    async onSavedProcedureHandler() {
      this.data.isOpen = false;
      this.data.showRequestProcedureAdd = false;
      this.data.hasProcedureLog = true;
      await this.$forceUpdate();
    },
    async onShowProcedureHistoryHandler() {
      this.data.isOpen = true;
      this.data.showRequestProcedureAdd = false;
      this.activeTab = TAB_ITEMS.ProcedureHistory;
      await this.$forceUpdate();
    },
    async onCancelChangeStatusHandler() {
      this.showChangeStatusPanel = false;
      this.data.isOpen = false;
      await this.$forceUpdate();
    },
    async onCancelAddCommentHandler() {
      this.showAddCommentPanel = false;
      this.data.isOpen = false;
    },
    async onSaveAddCommentHandler(payload) {
      try {
        let formData = objectToFormData(
          {
            studentSieId: this.data.studentSieId,
            categoryTypeId: commentTypes.ReferidosParteCAParteB,
            description: payload.comment
          },
          { indices: true }
        );

        if (payload.file) {
          formData.append("attachment", payload.file);
        }

        await studentService.saveComment(formData);
        this.ShowToast(
          "Completado",
          "Su información ha sido procesada exitosamente.",
          "success"
        );
        this.data.isOpen = false;
        this.showAddCommentPanel = false;
      } catch (e) {
        this.ShowToast("", e.message || "error", "error");
      }
    },
    async onSavedChangeStatusHandler() {
      this.showChangeStatusPanel = false;
      this.data.isOpen = false;
      this.$emit("on-change-status");
      await this.$forceUpdate();
    },
    async onActionsButtonClick() {
      await this.onLoadProcedureLogsHandler();
    },
    async onLoadProcedureLogsHandler() {
      const { data } = await referralStudentService.getRequestProcedureLogs(
        this.data.pcStudentId,
        this.isOnlineRegistration
      );
      this.referralProcedureLogs = [...data];
    },
    async onInactivateReferralHandler() {
      const confirm = await this.ShowCancelModal(
        "Confirmacion",
        `¿Está seguro(a) que desea inactivar la solicitud ${this.data.caseNumber}?`,
        "Si",
        "No"
      );

      if (!confirm) return;

      try {
        const payload = {
          id: this.data.pcStudentId,
          statusId: referralStatus.Inactive,
          typeId: this.data.requestTypeId
        };
        await referralStudentService.changeStatus(payload);

        this.$emit("on-change-status");

        this.ShowToast(
          "Proceso Exitoso",
          "La solicitud ha sido inactivada exitosamente.",
          "success"
        );
      } catch (e) {
        this.ShowToast("", e.message || "error", "error");
      }
    }
  }
};
</script>
<style lang="scss">
div:where(.swal2-container) .swal2-html-container {
  padding: 0;
}
</style>
<style lang="scss" scoped>
.badge-yellow {
  background-color: #f8ea80;
}

.badge-green-light {
  background-color: #a3e5b3;
}

.badge-gray {
  background-color: #b5c3bc;
}

.badge-violet {
  background-color: #ddb3d7;
}
.text-black {
  color: #11291b;
  font-weight: 700;
}
</style>
